// export action types
import { INIT_CALL_STATE, UPDATE_CALL_STATE, ADD_VERIFIED_MEMBER, CLEAR_CALL_STATE } from 'constants/redux-events';

/********************************************************/

/**
 * @type {function}
 * @param {object} payload - Initialize call state.
 * @property {string} type - Event name (from constant)
 * @property {object} payload - payload to dispatch
 * @example
 * import { initCallState } from 'actions/callState';
 *
 * // dispatch action
 * store.dispatch( initCallState( payload ) );
 */
export const initCallState = ( payload ) => {
    return {
        type: INIT_CALL_STATE,
        payload: payload
    };
};

/**
 * @type {function}
 * @param {object} payload - Update call state.
 * @property {string} type - Event name (from constant)
 * @property {object} payload - payload to dispatch
 * @example
 * import { updateCallState } from 'actions/callState';
 *
 * // dispatch action
 * store.dispatch( updateCallState( payload ) );
 */
export const updateCallState = ( payload ) => {
    return {
        type: UPDATE_CALL_STATE,
        payload: payload
    };
};

/**
 * @type {function}
 * @param {object} payload - Update call state.
 * @property {string} type - Event name (from constant)
 * @property {object} payload - payload to dispatch
 * @example
 * import { addVerifiedMember } from 'actions/callState';
 *
 * // dispatch action
 * store.dispatch( updateCallState( payload ) );
 */
export const addVerifiedMember = ( payload ) => {
    return {
        type: ADD_VERIFIED_MEMBER,
        payload: payload
    };
};

/**
 * @type {function}
 * @param {object} payload - Clear call state.
 * @property {string} type - Event name (from constant)
 * @property {object} payload - payload to dispatch
 * @example
 * import { clearCallState } from 'actions/callState';
 *
 * // dispatch action
 * store.dispatch( clearCallState() );
 */
export const clearCallState = () => {
    return {
        type: CLEAR_CALL_STATE,
        payload: null
    };
};
